// extracted by mini-css-extract-plugin
export var image = "logo-module--image--6c5d7";
export var logo = "logo-module--logo--61db1";
export var text = "logo-module--text--37151";
export var textSidebar = "logo-module--textSidebar--1b3f1";